// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerTickets_tickets__35F5N {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  line-height: 1em;\n  border: 2px solid var(--white-10);\n  padding: 2px 12px;\n  border-radius: 8px;\n}\n.headerTickets_tickets__35F5N > span:last-child {\n  text-shadow: none;\n  font-family: var(--default-font-family);\n  font-weight: bold;\n  background: var(--gold-gradient-bg);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}", ""]);
// Exports
exports.locals = {
	"tickets": "headerTickets_tickets__35F5N"
};
module.exports = exports;
